import React from "react"

import AsyncSelect from "../common/AsyncSelect";
import PartyModal from "../modal/Party";

export default class Party extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
          party: props.party,
          partyType: props.partyType,
        }
    }

    componentWillReceiveProps(props) {
        this.setState(props)
    }


    render(){
        let {
            party,
            partyType,
            showPartyModal
        } = this.state

        let value = party ? {
          value: party.id,
          label: party.name || party.identification_number,
        } : null

        return (
            <>
              <div className={"row"}>
                  <div className={"col"}>
                    <AsyncSelect
                        placeholder={this.props.placeholder}
                        endpoint={window.Api.Parties}
                        orderBy={"name"}
                        filter={`type=${partyType}`}
                        isClearable={true}
                        creatable={true}
                        disabled={this.props.disabled}
                        className={'custom-async-select__container'}
                        classNamePrefix={'custom-async-select'}
                        value={value}
                        getOptions={options => {
                            return options.map(option => ({
                                value: option.id,
                                label: `${option.name || option.identification_number}`,
                                data: option
                            }))
                        }}
                        onSelected={option => {
                            this.props.onSelected(option)
                        }}
                        onBlur={e => this.props.onBlur()}
                        onCreated={option => {
                            this.setState({
                                showPartyModal: true,
                            })
                        }}
                    />
                  </div>
                </div>
                {
                    showPartyModal &&
                    <PartyModal
                        name={"Party"}
                        show={showPartyModal}
                        party={party}
                        forcedPartyType={partyType}
                        onHide={() => this.setState({showPartyModal: false})}
                        onSubmit={(party) => {
                            this.props.onSelected(party)
                            this.setState({showPartyModal: false})
                        }}
                    />
                }
            </>
        )
    }
}

Party.defaultProps = {
  placeholder: "Select Party",
}
